var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header" },
    [
      _c("img", {
        staticClass: "header_logo",
        attrs: { src: require("../assets/whiteLogo.png"), alt: "" },
        on: {
          click: function($event) {
            return _vm.goPage("/")
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "header_right" }, [
        _c("span", { staticClass: "name" }, [
          _vm._v("Hi，" + _vm._s(_vm.info.name))
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            visible: _vm.dialogRelease,
            "close-on-click-modal": false,
            width: "1000px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogRelease = $event
            },
            close: _vm.closeEvent
          }
        },
        [
          _c(
            "div",
            { staticClass: "dialog" },
            [
              _c("release", { ref: "release" }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { background: "#d5001c", border: "0" },
                      attrs: { type: "primary", loading: _vm.btnLoading },
                      on: { click: _vm.submitRelease }
                    },
                    [_vm._v("发布")]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.checkVisible,
            "append-to-body": true,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.checkVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center", "margin-top": "20px" } },
            [
              _vm._v("\n\t\t\t\t内容包含敏感词："),
              _c("span", { staticStyle: { color: "#d5001c" } }, [
                _vm._v(_vm._s(_vm.sensitiveWord))
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { background: "#d5001c", border: "0" },
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.checkVisible = false
                    }
                  }
                },
                [_vm._v("确认")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69aae0e3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69aae0e3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pc/components/header.vue
// module id = null
// module chunks = 